import { render, staticRenderFns } from "./BusinessPendingDetails.vue?vue&type=template&id=6616e456&"
import script from "./BusinessPendingDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessPendingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports